<template>
  <a class="discovery-item-cover-image" :href="JsPAPI.util.itemURL(
    item,
    JsPAPI.api.getConfig(),
  )">
    <img v-show="loaded===true"
      :alt="item.Title"
      :src="image"
      @load="onImageLoad"
      ref="imageElement"
    />
    <div v-if="!loaded" class="discovery-item-cover-placeholder" :style="{ backgroundColor: randomColor() }">
      <div class="discovery-item-cover-placeholder-inner" :style="{ fontSize: fontSize() }">
        {{ title }}
      </div>
    </div>
  </a>
</template>

<script>

export default {
  name: 'ItemImage',
  data() {
    return {
      loaded: false,
      url: '',
      image: null,
      title: '',
    };
  },
  props: {
    item: Object,
    size: String,
  },
  created() {
    this.getImage();
    this.title = JsPAPI.util.cleanTitle(this.item.Title, true);
  },
  watch: {
    item() {
      this.getImage();
      this.title = JsPAPI.util.cleanTitle(this.item.Title, true);
    },
  },
  methods: {
    onImageLoad() {
      const img = this.$refs.imageElement;
      if (img?.width > 10 && img?.height > 10) {
        this.loaded = true;
        this.$emit('imageLoaded');
      }
    },
    fontSize() {
      const words = this.title.split(' ');
      const longest = words.reduce((pv, cv) => Math.max(pv, cv.length), 0);
      return `${Math.min(Math.ceil(100 / (longest * 0.5)), 16)}cqw`;
    },
    randomColor() {
      // eslint-disable-next-line no-bitwise
      return `hsla( ${~~(360 * Math.random())}, 20%, 80%, 1)`;
    },
    async getImage() {
      this.loaded = false;
      if (this.item.ThumbnailLink) this.image = this.item.ThumbnailLink;
      else {
        const size = this.size ?? this.$root.params?.coverSize ?? 'medium';
        const isbn = (this.item.ISBN) ? this.item.ISBN.split(' ')[0] : '';
        this.image = JsPAPI.util.syndeticsURL(
          JsPAPI.api.getConfig().synclient,
          isbn,
          this.item.UPC,
          this.item.OCLC,
          size,
        );
      }
    },
  },
};
</script>

<style scoped lang="less">
@import '~@/css/global';
.discovery-item-masonry {
}
.discovery-item-cover-image {
  display: block;
  text-decoration: none;
  img {
    width: 100%;
  }
}
.discovery-item-cover-placeholder {
  text-align: center;
  display: grid;
  place-items: center;
  padding: 5%;
  aspect-ratio: 0.7;
  color: #333;
  font-weight: bold;
  container-type: size;
  font-size: 12pt;
  overflow: hidden;
}
</style>
